/**
 * GroupDropdownSearch Selectors
 */
import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

// Selectors
import { selectGroups } from '../../../../services/groups/selectors';
import { selectCurrentEntityGroupIds } from '../../../../services/groupEntities/selectors';

// Utils
import orderBy from '../../../../utils/custom-orderBy';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

interface Props {
    includeUnassignedOption?: boolean;
}

const selectIncludeUnassignedOption = (state: *, props: Props) =>
    props.includeUnassignedOption;

const selectCurrentEntityGroups = createDeepEqualSelector(
    [selectCurrentEntityGroupIds, selectGroups],
    (currentEntityGroupIds, groupsState) => {
        if (!currentEntityGroupIds) return groupsState;
        return currentEntityGroupIds
            .map(value => groupsState[value])
            .filter(value => value);
    }
);

const selectData = createDeepEqualSelector(
    selectCurrentEntityGroups,
    currentEntityGroupsState => Object.values(currentEntityGroupsState)
);

const selectFilteredData = createDeepEqualSelector(
    selectData,
    dataState => dataState
);

const selectOrderedData = createDeepEqualSelector(
    selectFilteredData,
    filteredDataState => orderBy(filteredDataState, 'name')
);

const selectOptions = createDeepEqualSelector(
    [selectOrderedData, selectIncludeUnassignedOption],
    (orderedDataState, includeUnassignedOptionState) =>
        (includeUnassignedOptionState
            ? [
                  {
                      key: -1,
                      text: 'Unassigned',
                      value: 'null'
                  }
              ]
            : []
        ).concat(
            orderedDataState.map(({ id, name }) => ({
                key: id,
                text: name,
                value: `${id}`
            }))
        )
);

export { selectOptions };
